import React, { useContext, useEffect, useState } from "react";
import { SquareLoader } from "react-spinners";
import { useNavigate, useParams } from "react-router-dom";

import AuthContext from "../contexts/AuthCtx";
import { applyAuthResponse } from "../api/auth";
import { api } from "../api/api";
import { toast } from "../utils/toast";
import { loginFromResponse } from "../utils/authRedirect";
import { identifyUser } from "../analytics";

function Auth() {
  const [isLoading, setIsLoading] = useState(true);
  const AuthCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    if (!token) {
      setIsLoading(false);
      navigate("/login");
      return;
    }

    api
      .post("/auth/magic-login", { token })
      .then((response) => {
        const data = applyAuthResponse(response);
        identifyUser({
          id: data.user?._id,
          email: data.user?.email,
          userStatus: data.user?.userStatus,
          userRole: data.user?.userRole,
        });
        loginFromResponse(AuthCtx, data, navigate);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            "Le lien de connexion a expiré. Veuillez en demander un nouveau."
        );
        navigate("/login");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [AuthCtx, navigate, token]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <SquareLoader size={80} color="#823779" loading={isLoading} />
    </div>
  );
}

export default Auth;
